/// <amd-module name="VSS/Features/Monaco/Components/Editor" />
import { EditorBase } from "VSS/Features/Monaco/Components/EditorBase";
import { IEditorProps } from "VSS/Features/Monaco/Contracts";
import { VssComponent } from "VSS/Platform/Layout";

export class Editor extends EditorBase<IEditorProps> {
    public static readonly componentTypeName: string = "code-editor";

    protected setEditorContent(editor: monaco.editor.IEditor): void {
        if (editor && !!this.props.content) {
            const contentModel = this.createEditorModel(this.props.content.content, this.props.content.contentType, this.props.content.contentUri);
            editor.setModel(contentModel);
            editor.setPosition({
                lineNumber: 1,
                column: 1
            });

            editor.layout();
        }
    }

    protected createEditor(domElement: HTMLElement, options?: monaco.editor.IEditorConstructionOptions): monaco.editor.IEditor {
        const editor = monaco.editor.create(domElement, options);
        if (this.props.onContentUpdated) {
            editor.onDidChangeModelContent(() => this.sendThrottledContentChangedEvent());
        }
        return editor;
    }

    protected updateEditorContent(editor: monaco.editor.IEditor): void {
        if (editor && !!this.props.content) {
            const model = editor.getModel() as monaco.editor.IModel;
            if (model) {
                // Check if the content is udpated or not. Reason to have a check is
                // Updating the content of editor is costly and may result in flicker
                if (model.getValue() !== this.props.content.content) {
                    model.setValue(this.props.content.content);
                }
            }
        }
    }
}

VssComponent.register(Editor.componentTypeName, Editor);
